// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__SoBaI","cell":"ColumnAccessor_cell__bYmFP","firstCellAccent":"ColumnAccessor_firstCellAccent__3rR71"};